import React from 'react';
import { ArrowDown } from 'lucide-react';
import SplineScene from './SplineScene';
import { companyInfo } from '../data/mock';

const HeroSection = () => {
  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-content">
        <div className="hero-left">
          <h1 className="hero-title">
            <span className="title-line">{companyInfo.name}</span>
            <span className="title-accent">{companyInfo.tagline}</span>
          </h1>
          
          <p className="hero-description">
            {companyInfo.description}
          </p>
          
          <div className="hero-buttons">
            <button className="btn-primary" onClick={scrollToAbout}>
              <span>Objevit více</span>
              <ArrowDown size={18} />
            </button>
            <button className="btn-secondary" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
              <span>Kontaktovat</span>
            </button>
          </div>
        </div>
        
        <div className="hero-right">
          <SplineScene />
        </div>
      </div>
      
      <div className="hero-scroll-indicator" onClick={scrollToAbout}>
        <div className="scroll-line"></div>
        <span>Scroll</span>
      </div>
    </section>
  );
};

export default HeroSection;
